<template>
  <div class="w-full px-5 md:px-0">
    <!-- List -->
    <ul v-if="faqs && faqs.length">
      <FaqsListItem
        v-for="(faq, index) of faqs"
        :key="faq.id"
        :open="faq.open"
        :question="faq.title"
        :index="index"
        @toggled="updateOpenStatus"
        >{{ faq.body }}</FaqsListItem
      >
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { Faq } from '@robustastudio/e-commerce/common';

const props = defineProps({
  faqsList: {
    type: Array as PropType<Array<Faq>>,
    default: () => [],
  },
});

const faqs = ref(
  props.faqsList.map((faq: Faq) => {
    return { ...faq, open: false };
  }),
);

/**
 * Updates open status for faq items.
 *
 * @param isOpen Whether to open or close the item with the passed index.
 * @param toggledIndex The currently toggled item's index.
 */
function updateOpenStatus(isOpen = false, toggledIndex = -1) {
  // Onclose, close current only, otherwise open current and collapse others.
  if (!isOpen) {
    faqs.value[toggledIndex].open = false;
  } else {
    faqs.value = faqs.value.map((faq, index) => {
      return { ...faq, open: index === toggledIndex };
    });
  }
}
</script>
